import Element from './element.constants';

export default {
  Element,
  comment: {
    count: 2,
    cutoff: 150,
    overflowText: '... <span class="overflow-text">[Open sample online for full comment]</span>'
  }
};
